import { type AirDatepickerOptions } from 'air-datepicker'

const SVG = {
  prev: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  next: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
}

const datepickerOptions = (): AirDatepickerOptions<HTMLInputElement> => ({
  // autoClose: true,
  multipleDatesSeparator: ' - ',
  prevHtml: SVG.prev,
  nextHtml: SVG.next,
  navTitles: {
    days: 'yyyy MMMM',
  },
  autoClose: true,
  dateFormat: 'dd.MM.yyyy',
  position: ({ $datepicker, $target, done }) => {
    const { top, left, height, width } = $target.getBoundingClientRect()

    const { width: datepickerWidth } = $datepicker.getBoundingClientRect()
    const leftCalc =
      width - datepickerWidth > 0 ? left : left - (datepickerWidth - width)
    const topCalc = top + window.scrollY + height + 20

    $datepicker.style.left = `${leftCalc}px`
    $datepicker.style.top = `${topCalc}px`

    return function completeHide() {
      done()
    }
  },
})

export { datepickerOptions }
